import React from 'react';
import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    RouterProvider,
} from "react-router-dom";
import {Auth0Provider} from '@auth0/auth0-react';

import reportWebVitals from './reportWebVitals';
import './assets/scss/reset.css';
import ErrorPage from "./common/ErrorPage";
import BaseLayout from "./common/BaseLayout";
import PageHome from "./pages/PageHome";
import PageDetail from "./pages/PageDetail";
import PageLogin from "./pages/PageLogin";
import ProtectedRoute from "./common/ProtectedRoute";
import PageNew from "./pages/PageNew";

const router = createBrowserRouter([
    {
        path: "/",
        element: <BaseLayout/>,
        errorElement: <ErrorPage/>,
        children: [
            {
                path: "/",
                element: <ProtectedRoute children={<PageHome/>} />,
            },
            {
                path: "/new-job",
                element: <ProtectedRoute children={<PageNew/>} />,
            },
            {
                path: "/detail/:jobId",
                element: <ProtectedRoute children={<PageDetail/>} />,
            },
            {
                path: "/login",
                element: <PageLogin/>,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        domain="berger-group.eu.auth0.com"
        clientId="4oaxJRxAZ2afqwQgMG8Dsm1xHksgWadf"
        audience={"http://localhost:3000"}
        cacheLocation={'localstorage'}
        authorizationParams={{
            redirect_uri: process.env.PUBLIC_URL+'/login'
        }}
    >

            <RouterProvider router={router}/>

    </Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
